import { render } from "./AppMenuTrigger.vue?vue&type=template&id=fb80bafa&scoped=true"
import script from "./AppMenuTrigger.vue?vue&type=script&lang=js"
export * from "./AppMenuTrigger.vue?vue&type=script&lang=js"

import "./AppMenuTrigger.vue?vue&type=style&index=0&id=fb80bafa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb80bafa"]])

export default __exports__